import { create, FedopsLogger } from '@wix/fedops-logger';

let logger: FedopsLogger;

export enum LoadingPhase {
  Bootstrap = 'Bootstrap',
  Paint = 'Paint',
  ReceivedSettingsAndStyles = 'ReceivedSettingsAndStyles',
  ReceivedCurrentMemberDetails = 'ReceivedCurrentMemberDetails',
}

const init = ({ appName }: { appName: string }) => {
  logger = create(appName);
};

const appLoadingPhaseStart = (phaseName: LoadingPhase) =>
  logger.appLoadingPhaseStart(phaseName);

const appLoaded = () => logger.appLoaded();

const interactionStarted = (interaction: string) =>
  logger.interactionStarted(interaction);
const interactionEnded = (interaction: string) =>
  logger.interactionEnded(interaction);

export const fedopsLogger = {
  init,
  appLoadingPhaseStart,
  appLoaded,
  interactionStarted,
  interactionEnded,
};
